import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import Swal from 'sweetalert2';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';

interface PlanUiConfig {
  icon: string;
  accent: 'purple' | 'green' | 'gold';
  subtitle: string;
  features: string[];
  badge?: string;
  badgeType?: 'popular' | 'growth' | 'earlybird';
  ctaLabel: string;
  earlyBird: boolean;
  mediaAllowance?: string;
  footerNote?: string;
  supportsKingdomPartner?: boolean;
}

interface SponsorTier {
  name: string;
  price: string;
  description: string;
}

@Component({
  selector: 'app-my-subscration',
  templateUrl: './my-subscration.component.html',
  styleUrls: ['./my-subscration.component.css'],
})
export class MySubscrationComponent implements OnInit {
  today: string = moment().format('D MMM YYYY');
  subscriptionResult: any;
  mySubscriptionPlan: any = [];
  allPlans: Array<any> = [];
  displayPlans: Array<any> = [];
  subscriptionId: string;
  subscriptionPlanId: string = '';
  user: any;
  userSubscription: any;
  userSubs: any = [];
  planExpire: any;
  myBannerSub: any;
  public isSub: any;
  loading = true;
  isSubStatus = true;
  currentPlan: any;
  currentPlanDetail: any;
  message: any;
  isModalVisible = false;
  hasDiscount = false;
  freeKpStatus: any = null;
  activeTab: 'plans' | 'sponsors' = 'plans';
  // kingdomPartnerSelected: Record<string, boolean> = {};


  readonly kingdomPartnerBenefits = [
    'Kingdom Partner badge on your profile',
    '50% off advertising',
    '10% ministry giving impact',
    'Inclusion in Ravel Rewards directory',
    'Verified member benefit required',
  ];

  readonly sponsorTiers: SponsorTier[] = [
    {
      name: 'Sponsor',
      price: '$1,500/yr',
      description: 'Support the mission and gain community recognition.',
    },
    {
      name: 'Patron',
      price: '$5,000/yr',
      description: 'Expanded visibility and exclusive sponsor benefits.',
    },
    {
      name: 'Champion',
      price: '$10,000/yr',
      description: 'Premium placement and leadership recognition.',
    },
    {
      name: 'Ambassador',
      price: '$25,000+/yr',
      description: 'Top-tier partnership with maximum visibility.',
    },
  ];

  private readonly planConfig: Record<string, PlanUiConfig> = {
    'Marketplace Pro': {
      icon: 'fa-store',
      accent: 'purple',
      subtitle:
        'Designed for businesses actively seeking leads, referrals, and growth.',
      features: [
        'Priority search placement',
        'Lead generation tools',
        'AI lead matching',
        'Featured business placement',
        'Premium business showcase',
        'Multi-location ready',
        'Advertisements',
        'Priority email support',
      ],
      badge: 'BEST FOR GROWTH',
      badgeType: 'growth',
      ctaLabel: 'Subscribe Now',
      earlyBird: false,
      supportsKingdomPartner: true,
    },
    'Community Builder': {
      icon: 'fa-users',
      accent: 'green',
      subtitle:
        'Expand beyond your church and reach Christians across the Ravel marketplace.',
      features: [
        'Global marketplace visibility',
        'Featured business placement',
        'Advertisements',
        'Member discount directory',
        '10% ministry giving impact',
        'Networking opportunities',
        'Content sharing',
        'Priority email support',
      ],
      badge: 'MOST POPULAR',
      badgeType: 'popular',
      ctaLabel: 'Subscribe Now',
      earlyBird: false,
      mediaAllowance: 'Up to 5 Photos',
      supportsKingdomPartner: true,
    },
    'Founding Partner': {
      icon: 'fa-crown',
      accent: 'gold',
      subtitle: 'Lifetime access with exclusive founding partner benefits.',
      features: [
        'Lifetime Marketplace Pro',
        'Exclusive founder badge',
        'No future subscription increases',
        'Premium visibility',
        'Priority support',
        'Exclusive events',
        'Early access to new features',
      ],
      ctaLabel: 'Subscribe Now',
      earlyBird: true,
      footerNote: 'Limited to the first 100 partners only',
    },
    Founder: {
      icon: 'fa-crown',
      accent: 'gold',
      subtitle: 'Lifetime access with exclusive founding partner benefits.',
      features: [
        'Lifetime Marketplace Pro',
        'Exclusive founder badge',
        'No future subscription increases',
        'Premium visibility',
        'Priority support',
        'Exclusive events',
        'Early access to new features',
      ],
      ctaLabel: 'Subscribe Now',
      earlyBird: true,
      footerNote: 'Limited to the first 100 partners only',
    },
    'Business Builder': {
      icon: 'fa-store',
      accent: 'purple',
      subtitle:
        'Designed for businesses actively seeking leads, referrals, and growth.',
      features: [
        'Priority search placement',
        'Lead generation tools',
        'AI lead matching',
        'Featured business placement',
        'Premium business showcase',
        'Multi-location ready',
        'Advertisements',
        'Priority email support',
      ],
      badge: 'BEST FOR GROWTH',
      badgeType: 'growth',
      ctaLabel: 'Subscribe Now',
      earlyBird: false,
      supportsKingdomPartner: true,
    },
    'Business Quarterly': {
      icon: 'fa-store',
      accent: 'purple',
      subtitle:
        'Designed for businesses actively seeking leads, referrals, and growth.',
      features: [
        'Priority search placement',
        'Lead generation tools',
        'AI lead matching',
        'Featured business placement',
        'Premium business showcase',
        'Multi-location ready',
        'Advertisements',
        'Priority email support',
      ],
      badge: 'BEST FOR GROWTH',
      badgeType: 'growth',
      ctaLabel: 'Subscribe Now',
      earlyBird: false,
      supportsKingdomPartner: true,
    },
  };

  private readonly defaultPlanConfig: PlanUiConfig = {
    icon: 'fa-star',
    accent: 'purple',
    subtitle: 'Grow your business with Ravel.',
    features: ['Plan benefits included', 'Community access', 'Email support'],
    ctaLabel: 'Subscribe Now',
    earlyBird: false,
  };

  constructor(
    public router: Router,
    public authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    const planDetail = localStorage.getItem('planDetail');
    if (!planDetail) {
      this.openModal();
    }
    this.mySubscription();
    this.subscriptionPlans(this.isSubStatus);
    this.route.queryParams.subscribe((params) => {
      this.isSub = params['isSub'];
    });
    this.getProfile();
    this.checkDiscountExists();
  }

  checkDiscountExists() {
    this.authenticationService.getPerpetualAdd().subscribe(
      (response: any) => {
        const desc = response?.data?.description;
        this.hasDiscount = !!(desc && desc.trim() !== '');
      },
      (error) => {
        this.hasDiscount = false;
      }
    );
  }

  openModal(): void {
    this.isModalVisible = true;
  }

  closeModal(): void {
    this.isModalVisible = false;
  }

  onBackdropClick(event: MouseEvent) {
    if (event.target === event.currentTarget) {
      this.closeModal();
    }
  }

  setActiveTab(tab: 'plans' | 'sponsors') {
    this.activeTab = tab;
  }

  public subscriptionPlans(val): void {
    this.loading = true;
    this.spinner.show();
    this.authenticationService.getPlan(val).subscribe(
      (response: any) => {
        const data = response?.data || [];
        this.allPlans = Array.isArray(data) ? data : [];
        this.displayPlans = this.buildDisplayPlans(this.allPlans);
        this.getProfile();
        this.loading = false;
        this.spinner.hide();
      },
      (error) => {
        this.loading = false;
        this.spinner.hide();
        if (error.error.message == 'Unauthorized') {
          this.authenticationService.logout();
        }
      }
    );
  }
  // 🔥 KINGDOM PARTNER REQUEST FUNCTION
  requestKingdomPartner(plan: any) {
    if (!this.hasDiscount) {
      Swal.fire(
        'Discount Required',
        'Kingdom Partner status requires an exclusive/most favored customer discount. Please create your best discount to apply.',
        'warning'
      );
      return;
    }

    this.authenticationService.requestKingdomPartner().subscribe(
      () => {

        // sync latest state from backend
        this.getProfile();

        Swal.fire(
          'Request sent',
          'Awaiting admin approval',
          'success'
        );
      },
      (err) => {
        Swal.fire(
          'Error',
          err?.error?.message || 'Something went wrong',
          'error'
        );
      }
    );
  }

  requestKingdomPartnerFree() {
    if (!this.hasDiscount) {
      Swal.fire(
        'Discount Required',
        'Kingdom Partner status requires an exclusive/most favored customer discount. Please create your best discount to apply.',
        'warning'
      );
      return;
    }

    this.authenticationService.requestKingdomPartner().subscribe(
      () => {
        this.getProfile();
        Swal.fire('Request sent', 'Awaiting admin approval', 'success');
      },
      (err) => {
        Swal.fire('Error', err?.error?.message || 'Something went wrong', 'error');
      }
    );

  }

  // 🔥 KINGDOM PARTNER REVERT FUNCTION
  revertKingdomPartner(plan: any) {
    this.authenticationService.cancelKingdomPartnerRequest().subscribe(
      () => {
        // sync latest state from backend
        this.getProfile();

        Swal.fire(
          'Reverted',
          'Your Kingdom Partner request has been reverted.',
          'success'
        );
      },
      (err) => {
        Swal.fire(
          'Error',
          err?.error?.message || 'Something went wrong',
          'error'
        );
      }
    );
  }

  revertKingdomPartnerFree() {
    this.authenticationService.cancelKingdomPartnerRequest().subscribe(
      () => {
        this.getProfile();
        Swal.fire(
          'Reverted',
          'Your Kingdom Partner request has been reverted.',
          'success'
        );
      },
      (err) => {
        Swal.fire(
          'Error',
          err?.error?.message || 'Something went wrong',
          'error'
        );
      }
    );
  }

  showRevertButton(plan: any): boolean {
    return (
      plan?.kingdom_partner_status === 'pending' ||
      plan?.kingdom_partner_status === 'approved'
    );
  }

  isRevertDisabled(plan: any): boolean {
    return plan?.kingdom_partner_status === 'approved';
  }
  private buildDisplayPlans(apiPlans: any[]): any[] {
    if (!apiPlans?.length) {
      return [];
    }

    const slots: Array<{
      normalizedCaption: string;
      match: (plan: any) => boolean;
    }> = [
        {
          normalizedCaption: 'Community Builder',
          match: (plan) => {
            const caption = (plan?.caption || '').toLowerCase();
            return (
              caption.includes('community builder') &&
              !caption.includes('kingdom')
            );
          },
        },
        {
          normalizedCaption: 'Marketplace Pro',
          match: (plan) => {
            const caption = (plan?.caption || '').toLowerCase();
            return (
              (caption.includes('marketplace pro') ||
                caption.includes('business builder') ||
                caption.includes('business quarterly')) &&
              !caption.includes('kingdom')
            );
          },
        },
        {
          normalizedCaption: 'Founding Partner',
          match: (plan) => {
            const caption = (plan?.caption || '').toLowerCase().trim();
            return (
              caption.includes('founding partner') ||
              caption === 'founder' ||
              Number(plan?.price) === 995
            );
          },
        },
      ];

    const usedIds = new Set<string>();
    const result: any[] = [];

    for (const slot of slots) {
      const found = apiPlans.find(
        (plan) => plan?._id && !usedIds.has(plan._id) && slot.match(plan)
      );
      if (found) {
        usedIds.add(found._id);
        result.push({
          ...found,
          caption: slot.normalizedCaption,
          _originalCaption: found.caption,
        });
      }
    }

    if (result.length > 0) {
      return result;
    }

    return apiPlans
      .filter((plan) => {
        const caption = (plan?.caption || '').toLowerCase();
        return (
          Number(plan?.price) > 0 &&
          !caption.includes('congregational') &&
          !caption.includes('affiliate') &&
          !caption.includes('community listing') &&
          !caption.includes('kingdom sponsor') &&
          !caption.includes('sponsor')
        );
      })
      .sort((a, b) => Number(a?.price) - Number(b?.price))
      .slice(0, 3);
  }


  // private buildDisplayPlans(apiPlans: any[]): any[] {
  //   const slots: Array<{
  //     normalizedCaption: string;
  //     match: (plan: any) => boolean;
  //     fallbackPrice: number;
  //     fallbackDescription: string;
  //   }> = [
  //       {
  //         normalizedCaption: 'Community Builder',
  //         match: (plan) => {
  //           const caption = (plan?.caption || '').toLowerCase();
  //           return (
  //             caption.includes('community builder') &&
  //             !caption.includes('kingdom')
  //           );
  //         },
  //         fallbackPrice: 15,
  //         fallbackDescription: 'Expand beyond your church and reach Christians across the Ravel marketplace.',
  //       },
  //       {
  //         normalizedCaption: 'Marketplace Pro',
  //         match: (plan) => {
  //           const caption = (plan?.caption || '').toLowerCase();
  //           return (
  //             (caption.includes('marketplace pro') ||
  //               caption.includes('business builder') ||
  //               caption.includes('business quarterly')) &&
  //             !caption.includes('kingdom')
  //           );
  //         },
  //         fallbackPrice: 39,
  //         fallbackDescription: 'Designed for businesses actively seeking leads, referrals, and growth.',
  //       },
  //       {
  //         normalizedCaption: 'Founding Partner',
  //         match: (plan) => {
  //           const caption = (plan?.caption || '').toLowerCase().trim();
  //           return (
  //             caption.includes('founding partner') ||
  //             caption === 'founder' ||
  //             Number(plan?.price) === 995
  //           );
  //         },
  //         fallbackPrice: 995,
  //         fallbackDescription: 'Lifetime access with exclusive founding partner benefits.',
  //       },
  //     ];

  //   const usedIds = new Set<string>();
  //   const result: any[] = [];

  //   for (const slot of slots) {
  //     const found = apiPlans?.find(
  //       (plan) => plan?._id && !usedIds.has(plan._id) && slot.match(plan)
  //     );
  //     if (found) {
  //       usedIds.add(found._id);
  //       result.push({
  //         ...found,
  //         caption: slot.normalizedCaption,
  //         _originalCaption: found.caption,
  //       });
  //     }
  //     else {
  //       result.push({
  //         _id: null,
  //         caption: slot.normalizedCaption,
  //         price: slot.fallbackPrice,
  //         description: slot.fallbackDescription,
  //         type: 'Basic',
  //         days: 30,
  //         isUnavailable: true,
  //       });
  //     }
  //   }

  //   if (result.length > 0) {
  //     return result;
  //   }

  //   return (apiPlans || [])
  //     .filter((plan) => {
  //       const caption = (plan?.caption || '').toLowerCase();
  //       return (
  //         Number(plan?.price) > 0 &&
  //         !caption.includes('congregational') &&
  //         !caption.includes('affiliate') &&
  //         !caption.includes('community listing') &&
  //         !caption.includes('kingdom sponsor') &&
  //         !caption.includes('sponsor')
  //       );
  //     })
  //     .sort((a, b) => Number(a?.price) - Number(b?.price))
  //     .slice(0, 3);
  // }

  convertSubscripitonType(days) {
    if (days === 365) {
      return 'Yearly';
    } else if (days === 30) {
      return 'Monthly';
    } else if (days === 90) {
      return 'Quarterly';
    } else if (days === 180) {
      return 'Half Yearly';
    } else if (days > 365) {
      return 'Lifetime';
    }
    return 'Days';
  }

  getPlanConfig(plan: any): PlanUiConfig {
    return this.planConfig[plan?.caption] || this.defaultPlanConfig;
  }

  supportsKingdomPartner(plan: any): boolean {
    return !!this.getPlanConfig(plan).supportsKingdomPartner;
  }

  // isKingdomPartnerSelected(plan: any): boolean {
  //   return !!this.kingdomPartnerSelected[plan?._id];
  // }

  // toggleKingdomPartner(plan: any, event: Event) {
  //   const checked = (event.target as HTMLInputElement).checked;
  //   this.kingdomPartnerSelected[plan._id] = checked;
  // }

  isKingdomPartnerSelected(plan: any): boolean {
    return plan?.kingdom_partner_status === 'approved';
  }



  getPlanDisplayName(plan: any): string {
    if (this.isKingdomPartnerSelected(plan)) {
      return `${plan?.caption} · Kingdom Partner`;
    }
    return plan?.caption;
  }

  hasEarlyBirdOffer(plan: any): boolean {
    return this.getPlanConfig(plan).earlyBird;
  }

  isFoundingPartner(plan: any): boolean {
    const caption = plan?.caption || '';
    return caption === 'Founding Partner' || caption === 'Founder';
  }

  getEarlyBirdPrice(): string {
    return '495';
  }

  getDisplayTotal(plan: any): string {
    if (!plan?.amount && !plan?.price) {
      return '0';
    }
    const amount = plan?.amount ?? plan?.price;
    if (this.isFoundingPartner(plan) || amount === 995) {
      return '495 (Lifetime)';
    }
    return Number(amount).toFixed(2);
  }

  getMonthlyPrice(plan: any): string {
    const caption = plan?.caption;
    if (caption === 'Community Builder') {
      return '15';
    }
    if (caption === 'Marketplace Pro') {
      return '39';
    }
    if (plan?.days === 30) {
      return String(plan.price);
    }
    if (plan?.days === 365) {
      return (plan.price / 12).toFixed(0);
    }
    return String(plan?.price || '0');
  }

  getAnnualBillingNote(plan: any): string {
    const caption = plan?.caption;
    if (caption === 'Community Builder') {
      return 'Billed annually ($180/year)';
    }
    if (caption === 'Marketplace Pro') {
      return 'Billed annually ($468/year)';
    }
    if (plan?.days === 365) {
      return `Billed annually ($${plan.price}/year)`;
    }
    if (plan?.days === 30) {
      return 'Billed monthly';
    }
    return '';
  }

  isCurrentPlan(plan: any): boolean {
    return !!plan?._id && plan?._id === this.userSubscription;
  }

  redirect() {
    this.router.navigate(['/dashboard']);
  }

  checkDate(date: any) {
    date = new Date(date);
    date.setFullYear(date.getFullYear() + 1);
    return date;
  }

  clickcancel(id, i?) {
    Swal.fire({
      title: 'Are you sure?',
      html: 'Your subscription/advertisements will continue for the duration of your current plan but they will not renew.<br/><br/>If you decide to re-subscribe later, it will be at current pricing.<br/><br/>Do you still want to cancel?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d0550e',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Cancel Subscription',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.isConfirmed) {
        this.authenticationService
          .cancelCommonMerchantSubscription({ id })
          .subscribe(
            (response: any) => {
              localStorage.removeItem('planDetail');
              this.subscriptionResult?.splice(i, 1);
              Swal.fire(
                'Cancel!',
                'Your Subscription has been Canceled.',
                'success'
              );
              if (this.myBannerSub.length) this.cancelSubscription();
              this.getProfile();
              this.mySubscription();
              this.userSubs = [];
            },
            (error) => {
              console.log('error', error);
            }
          );
      }
    });
  }

  cancelSubscription() {
    this.authenticationService
      .cancelBannerSubscription(this.myBannerSub[0]._id)
      .subscribe(
        (response: any) => {
          localStorage.removeItem('planDetail');
        },
        (error) => {
          console.error(error);
        }
      );
  }

  mySubscription() {
    this.authenticationService.getPlan(true).subscribe((res: any) => {
      this.mySubscriptionPlan = this.buildDisplayPlans(res?.data || []);
    });
  }

  getProfile() {
    this.authenticationService.getProfile().subscribe(
      (response: any) => {
        this.userSubscription = response?.data?.subscriptionPlanType;
        let mySubscriptions = response?.data?.subscriptions;
        this.myBannerSub = response?.data?.bannerPlanType;
        const kingdomStatus = response?.data?.kingdom_partner_status;
        this.freeKpStatus = kingdomStatus;

        this.displayPlans = this.displayPlans.map((plan) => ({
          ...plan,
          kingdom_partner_status:
            plan._id === this.userSubscription ? kingdomStatus : null,
        }));
        if (this.userSubscription) {
          if (this.userSubscription && this.allPlans.length > 0) {
            this.currentPlanDetail = this.allPlans.filter(
              (item) => item._id === this.userSubscription
            );
          }
          this.currentPlan = mySubscriptions.filter(
            (item: any) => item.timeRef === this.userSubscription
          );
          if (
            this.currentPlan &&
            this.currentPlan.length > 0 &&
            this.currentPlanDetail &&
            this.currentPlanDetail.length > 0
          ) {
            this.currentPlan[0]['caption'] = this.currentPlanDetail[0].caption;
            this.userSubs = this.currentPlan;
            if (this.userSubs) {
              this.planExpire = this.userSubs[0]?.validTill;
            }
          }
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  getSubscription(planObj: any) {
    console.log("--------------------------------------helo--------------------------------------")
    if (!planObj?._id || planObj?.isUnavailable) {
      Swal.fire('Coming Soon', 'This plan is not available for subscription right now. Please contact support.', 'info');
      return;
    }

    const kingdomPartner = this.isKingdomPartnerSelected(planObj);
    const planPayload = {
      ...planObj,
      kingdomPartner,
      kingdomPartnerLabel: kingdomPartner
        ? `${planObj.caption} Kingdom Partner`
        : planObj.caption,
    };

    localStorage.setItem('plan', JSON.stringify(planPayload));

    if (this.userSubs && this.userSubs.length > 0) {
      Swal.fire(
        'You are already subscribed to a base plan. Please cancel your subscription to proceed.'
      );
      setTimeout(() => {
        window.location.reload();
      }, 3000);

      return false;
    }
    if (this.isSub == 'true') {
      if (planObj._id) {
        this.subscriptionPlanId = planObj._id;
        setTimeout(
          () =>
            this.router.navigate(['/base-payment'], {
              queryParams: {
                id: planObj._id,
                kingdomPartner: kingdomPartner ? 'true' : 'false',
              },
            }),
          400
        );
      }
    } else if (this.isSub === 'false') {
      this.router.navigateByUrl('/select-criteria');
    }
  }

  updateSubscriptionPlan() {
    let data = {
      subscriptionPlanType: this.subscriptionPlanId,
    };
    this.authenticationService.updateUserSubscription(data).subscribe(
      (response: any) => {
        this.getProfile();
        Swal.fire(
          'Subscription Changed Successfully',
          response.message,
          'success'
        );
      },
      (error) => {
        Swal.fire('Oops...', error.error.message, 'error');
      }
    );
  }

  subscriptionPage() {
    window.open('https://personal.ravel.faith/#/subscribe', '_blank');
  }

  viewSponsorDetails() {
    window.open('https://personal.ravel.faith/#/subscribe', '_blank');
  }
}
